import { render, staticRenderFns } from "./PageManagedContractFields.vue?vue&type=template&id=48a6d70e&"
import script from "./PageManagedContractFields.vue?vue&type=script&lang=js&"
export * from "./PageManagedContractFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports